<template>
    <div id="hero-element" :class="{empty: !moduleData}">
        <div class="module" v-if="moduleData" :class="{full: moduleData.FullHeightHero}" :id="moduleData.AnchorID">
            <b-img-lazy v-bind="heroImageProps" v-if="moduleData.DisplayHero && moduleData.DisplayHero.ID" :src="moduleData.DisplayHero.URL"
                        @load.native="heroImageLoaded = true"
                        :class="{loaded: heroImageLoaded}"></b-img-lazy>
            <div class="hero-body" v-if="moduleData.Title && moduleData.ShowTitle">
                <p class="fancy-title">{{moduleData.Title}}</p>
                <p v-if="moduleData.Subtitle" v-html="moduleData.Subtitle"></p>
            </div>
            <div class="hero-footer">
                <i class="fal fa-long-arrow-down" @click="scrollToElement"></i>
                <hr>
                <div class="notice" v-if="moduleData.ShowNotices" v-for="(notice, index) in getSettings.Notices" :key="'notice' + index"
                     :class="notice.ColourClass"
                     :style="'--animation-order:' + index">
                    <div>
                        <span class="icon"><i class="fal" :class="notice.Icon"></i></span>
                        <div class="message" ref="noticeMessage" v-html="notice.Title"></div>
                        <span class="icon"><i class="fal fa-times" @click="markNoticeAsClosed(notice.ID)"></i></span>
                    </div>
                </div>
            </div>
        </div>
        <Loading v-else/>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";
    import Loading from '../Loading';

    export default {
        name: "HeroElement",
        components: {
            Loading
        },
        data() {
            return {
                heroImageProps: {
                    center: true,
                    fluidGrow: true,
                    blank: true,
                    blankColor: '#fff'
                },
                heroImageLoaded: false
            }
        },
        props: {
            component: {
                type: Object,
            }
        },
        computed: {
            ...mapGetters(['getModuleData', 'getSettings']),
            moduleData() {
                return this.getModuleData(this.component.ID);
            }
        },
        methods: {
            ...mapActions(['markNoticeAsClosed']),
            scrollToElement() {
                const nextElement = $(this.$el).next();
                if (nextElement.length) {
                    nextElement[0].scrollIntoView({behavior: 'smooth'});
                }
            }
        }
    }
</script>
